import React, { useState } from "react";
import {  Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import { API_URL } from "../constant";
// import swal from "sweetalert";
// import axios from "axios";
import {  useNavigate } from "react-router-dom";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

//import $, { param, readyException } from 'jquery';


const ViewInv = (props) => {
 // const [userData, setUserData] = useState([]);
 
  /********************************************************** */
  const navigat = useNavigate();


  const mainPage = () => {
    window.location.reload();

  }

  return (
    <>
      <Modal
        show={props.show}
        /*cancel={props.close}*/
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header closeButton onClick={props.close} >
          <Modal.Title id="contained-modal-title-vcenter">Inventory list of {props.invUser}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4></h4>

          <div className="row">

            <div className="col-md-12">
              <div className="form-group row">
                <div className="table-responsive pt-3">
                 
                  <table className="table table-bordered display  nowrap" id="example">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Available Quantity</th>
                       
                      </tr>
                    </thead>
                    <tbody>

                      {props.data.map((udata, index) => (
                        <tr key={index}>
                          <td> {udata.item_name}</td>
                          <td> {udata.avail_qty}</td>
                        </tr>
                      )
                      )}

                    </tbody>
                  </table>
                </div>

              </div>
            </div>



          </div>

        </Modal.Body>
        <Modal.Footer>
          
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewInv;
